import Vue from 'vue';
import VueLogger from 'vuejs-logger';
import Keycloak from 'keycloak-js';
import { Permissions } from '../permissions/permissions';

// todo:
// * token refresh stuff


function initLogger() {
  const isProduction = process.env.NODE_ENV === 'production';
  const options = {
    isEnabled: true,
    logLevel: isProduction ? 'error' : 'debug',
    stringifyArguments: false,
    showLogLevel: true,
    showMethodName: true,
    separator: '|',
    showConsoleColors: true
  };

  Vue.use(VueLogger, options);
}

function KeycloakAuth(options) {
  this.options = options;
  this.keycloak = Keycloak(this.options);
  initLogger();

  this.keycloak.onTokenExpired = () => {
    this.keycloak.updateToken(30)
    .then(() => {
      this.state.accessToken = this.keycloak.token;
      this.state.eventBus.$emit('access_token_refreshed');
    })
    .catch((er) => Vue.$log.error("Error refreshing token : ", er));
  }

  this.state = {
    isAuthenticated: false,
    accessToken: null,
    user: {
      providerId: null,
      uid: null,
      email: null,
      displayName: null,
      photoUrl: null,
      idToken: null,
      permissions: null,
    },
    eventBus: new Vue(),
    signOut: this.keycloak.logout,
    profile: this.keycloak.accountManagement
  }
  Vue.prototype.$auth = this.state;

  this.init = async function (callback) {
    // checkLoginIframe is set to false. This will make it impossible for the app to detect SSO sign-outs without reloading or token refresh, but is currently required
    // See : https://issues.redhat.com/browse/KEYCLOAK-12125
    const isAuthenticated = await this.keycloak.init({ onLoad: this.options.onLoad, checkLoginIframe: false });

    if (isAuthenticated) {
      const token = this.keycloak.tokenParsed;

      const extractClientRoles = (roles, client) => roles.concat(client.roles);
      const roles = Object.values(token.resource_access || []).reduce(extractClientRoles, token.realm_access.roles || []);
      
      this.state.isAuthenticated = true;
      this.state.accessToken = this.keycloak.token;
      this.state.user.providerId = token.iss;
      this.state.user.uid = token.preferred_username;
      this.state.user.email = token.email;
      this.state.user.displayName = `${token.given_name} ${token.family_name}`;
      this.state.user.permissions = new Permissions(roles);

      callback();
    }
  }
}

export default KeycloakAuth;
